import App from './components/Keyboard'; // Import from components folder
import './index.css'; // Or wherever your global CSS is
import '@fontsource/namdhinggo/400.css';
import '@fontsource/namdhinggo/700.css';

export default App;